import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";
import { IconContext } from "react-icons/lib";
import ProductsDropDown from "./ProductsDropDown";
// import Announcebar from "./Announcebar";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [navMargin, setNavMargin] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  const showNavMargin = () => setNavMargin(!navMargin);

  const showButton = () => {
    if (window.innerwidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const [show, setShow] = useState(false);
  const [videoshow, setVideoShow] = useState(false);

  const [prodDrop, setProdDrop] = useState(false);

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
    {/* <Announcebar /> */}
      <IconContext.Provider value={{ color: "#fff" }}>
        <nav className="navbar">
          <div className="navbar-container">
            <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
              <img src="/images/virtuix_logo_white_110px.svg" alt="" />
            </Link>
            <div className="menu-icon" onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li
                className={navMargin ? "nav-item nav-margin" : "nav-item"}
                onClick={() => {setProdDrop(!prodDrop); showNavMargin()}}
                onMouseLeave={() => {setTimeout(() => {
                  setProdDrop(false); setNavMargin(false)
                }, 300);}}
              >
                <div className="nav-links-op">
                  Products
                  <img
                    className="products-dropdown-v-arrow"
                    src="/images/v_arrow_down_navbar.svg"
                    alt="Click Arrow Down"
                  />
                </div>
                {prodDrop && <ProductsDropDown />}
              </li>
              <li className="nav-item">
                <Link
                  to="/who-we-are"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Who We Are
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/careers"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Careers
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/developers"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Developers
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/press"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Press
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
